import { createSelector } from 'reselect';

import { AppState } from '../../../store';
import { commonSelector } from '../../Common/redux/selectors';

export const homeSelector = (state: AppState) => state.home;
export const homeStateSelector = createSelector(homeSelector, item => item);

export const homeFaqDataSelector = (state: AppState) => {
  return { faqData: state.home.faqData };
};

export const homeMetaDataSelector = (state: AppState) => {
  return { metaData: state.home.metaData };
};

export const homeGosafeBannerSelector = (state: AppState) => {
  return { goSafeBanner: state.home.goSafeBanner };
};

export const homeOffersSelector = (state: AppState) => {
  return { offers: state.home.offers };
};

export const rtcHomeBannerSelector = (state: AppState) => {
  return { rtcHomeBanner: state.home.rtcHomeBanner };
};

export const busHomeCarouselSelector = (state: AppState) => {
  return { busHomeCarousel: state.home.busHomeCarousel };
};

export const userLoyaltyInfo = (state: AppState) => {
  return { userLoyaltyInfo: state.home.userLoyaltyInfo }
}
